import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { useRequestProfileHeaderArchivedPipelines } from '../useRequestProfileHeaderArchivedPipelines'
import { useRequestProfileHeaderInfoItems } from '../useRequestProfileHeaderInfoItems'

export function useRequestProfileHeaderInfo() {
  const { arePhasesLoading, handleReloadRequestPhases, phases, requestData } =
    useRequestProfileContext()

  const {
    archivedPipelinesCount,
    handleLoadArchivedPipelinesCount,
    handleOpenArchivedPipelinesModal,
  } = useRequestProfileHeaderArchivedPipelines({
    requestId: requestData?.id,
  })

  const { infoItemsProps } = useRequestProfileHeaderInfoItems({
    arePhasesLoading,
    handleReloadRequestPhases,
    phases,
    onReloadArchivedPipelinesCount: handleLoadArchivedPipelinesCount,
  })

  return {
    infoItemsProps: {
      ...infoItemsProps,
      archivedPipelinesCount,
      onClickOpenArchivedPipelinesModal: handleOpenArchivedPipelinesModal,
    },
  }
}
